import { useQuery } from '@tanstack/react-query'

import { UsersService } from '../lib/users.service'

const INVITES_STATUSES_QUERY_KEY = 'invites-statuses'

export const useInvitesStatuses = () => {
  const { data } = useQuery({
    queryKey: [INVITES_STATUSES_QUERY_KEY],
    queryFn: () => UsersService.getInvitesStatuses(),
    select: data => data.data
  })

  return { data }
}
